import { ProcessStatusGroup } from '__generated__/graphql'

export const useProcessStatusColorMap = (
    summaryGroup: ProcessStatusGroup | ProcessStatusGroup[] | undefined
) => {
    if (Array.isArray(summaryGroup)) {
        return summaryGroup.map((group) => getProcessStatusGroupColor(group))
    } else {
        return [getProcessStatusGroupColor(summaryGroup)]
    }
}

export function getProcessStatusGroupColor(
    group: ProcessStatusGroup | undefined
): string {
    switch (group) {
        case ProcessStatusGroup.Mapping:
            return '#99D0FF'
        case ProcessStatusGroup.Interest:
            return '#80BCFF'
        case ProcessStatusGroup.Outreach:
            return '#3F8FDA'
        case ProcessStatusGroup.Submitted:
            return '#006CB5'
        case ProcessStatusGroup.InProcess:
            return '#004583'
        case ProcessStatusGroup.OutOfProcess:
            return '#001D33'
        case ProcessStatusGroup.NoStatus:
        default:
            return '#707070'
    }
}
